type Conversion = {
  event: 'booking_confirmed' | 'membership_purchased';
  booking_id?: string;
  order_id?: string;
  price: number;
  currency: string;
  payment_status: 'paid' | 'free' | 'code' | 'credit' | 'pending';
  product: 'slot_30' | 'slot_60' | 'premium' | 'elite' | 'founding_pass';
  duration_min?: number;
};

const sent = new Set<string>();

/** Persistent per-browser deduplication; memory fallback when storage is blocked. */
export function pushConversionOnce(conversion: Conversion, id: string) {
  const key = `atomfit:conversion:${conversion.event}:${id}`;
  if (sent.has(key)) return;
  try {
    if (window.localStorage.getItem(key)) return;
  } catch { /* Storage may be unavailable. */ }
  const target = window as Window & { dataLayer?: Conversion[] };
  target.dataLayer = target.dataLayer || [];
  target.dataLayer.push(conversion);
  sent.add(key);
  try {
    window.localStorage.setItem(key, '1');
  } catch { /* Memory still prevents duplicate pushes during this visit. */ }
}
